export const INSUFFICIENT_RUNE_THRESHOLD_AMOUNT_ERROR =
  'Insufficient 1 RUNE threshold amount'

export const INVALID_MEMO_ERROR = 'Invalid Memo'
